/**
 * Google Analytics olayları (gtag gatsby-ssr'da yükleniyor). Reklamın işe yarayıp yaramadığını görmek için:
 *  - kanal_tiklama: WhatsApp kanalı / Telegram / Instagram bağlantısına tıklama (sitedeki her yer; konum = sayfa yolu)
 *  - magaza_tiklama: "Trendyol'da gör" gibi mağazaya yönlendirme (redirect sayfası açılınca)
 * GA4'te bu iki olay "temel etkinlik" (key event) işaretlenirse kaynak / kampanya bazında dönüşüm görünür.
 */
export const olay = (ad, parametreler) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", ad, parametreler);
    }
};

const KANALLAR = [
    [/whatsapp\.com\/channel/i, "whatsapp"],
    [/(^|\/\/)(t\.me|telegram\.me)\//i, "telegram"],
    [/instagram\.com/i, "instagram"],
];

/** Tüm sayfada tek dinleyici: kanal bağlantıları birçok bileşende (header, çekmece, hero, detay, footer) olduğu için. */
export const kanalTiklamalariniDinle = () => {
    document.addEventListener("click", (e) => {
        const a = e.target && e.target.closest && e.target.closest("a[href]");
        if (!a) return;
        const kanal = KANALLAR.find(([d]) => d.test(a.href));
        if (kanal) olay("kanal_tiklama", { kanal: kanal[1], konum: window.location.pathname });
    }, true);
};
